// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__177S5","col":"styles_col__DHspi"};